import { createAPI } from '../../common'

export default {
  // 新建报纸
  postPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztqbqfs', 'post', config),
  // 删除报纸
  deletePaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztqbqfs', 'delete', config),
  // 获取全部报纸
  getPaperAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztqbqfs0bmm',
      'get',
      config
    ),
  // 获取单个报纸
  getPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztqbqfs', 'get', config),
  // 报纸排序
  putPaperSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztqbqfs0tpsu', 'put', config),
  // 修改报纸
  putPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztqbqfs', 'get', config),
  // 校验名称和code
  getPaperCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztqbqfs0difdl', 'get', config)
}
